export enum LoginFlowState {
    Logout,
    Login,
    Default,
    LoggedInCheckIfLoggedOutAction,
    CompleteLoginFlow,
    UpdateAndGetUserToken,
    AskCpr,
    TokenDebug,
    ForceLogin,
}
